import {TrackedItem} from "@app/core/tracking/domain/entities/tracked-item";


const ITEM_BRAND = 'Europastry';

export class TrackedItemMapper {
    static serialize(params: TrackedItem) {
        return {
            item_id: params.itemId,
            item_name: params.itemName,
            item_brand: ITEM_BRAND,
            ...(params.quantity != null ? {quantity: params.quantity} : {}),
            ...(params.price != null ? {price: params.price} : {}),
        }
    }
}
